import PropTypes from 'prop-types';

import PointsSection from './PointsSection';
import PointsChart from './PointsChart';
import { StyledContainer } from './styles';

const PointsSectionChart = ({ data }) => {
  if (!data) return null;

  const { elements } = data;

  return (
    <StyledContainer>
      <PointsSection data={elements[0]} />
      <PointsChart data={elements[1]} />
    </StyledContainer>
  );
};

PointsSectionChart.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default PointsSectionChart;
